<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="true"
    :breadcrumb="getBreadcrumb">
    <div slot="custom-controls-top">
      <div class="controls__filters note">
        <health-explorer-controls
          v-model="selectedDay"
          :listenKeyEvents="listenKeyEvents"
          ref="expControls"
          v-on:input="requestUsersCharts()"
          v-on:inputFilter="filterChanged"
          :filters="getFilterOptions"
          :filterValue="getFilterOptions[0]"
        />
        <btn-pill
          class="btn-ok margin-left-l"
          :btnText="$t('health.explorer.multipleBoard.selectUsers')"
          btn-type="primary"
          btn-size="xs"
          @click="showUserSelector"/>

      </div>
    </div>
    <div class="container">
      <div class="header">
        <div class="header__title">
          <h1
            class="header-title">
            <chevron
              @click="$router.push({name: 'HealthExplorer'})"/>
            {{ $t('health.explorer.multipleBoard.title') }}
          </h1>
        </div>
      </div>
      <grid-row
        v-for="rowIndex in numRows"
        :key="rowIndex"
        column-align="center" col-spaced>
        <grid-col
          v-for="(userChart) in usersCharts.slice((rowIndex - 1) * numCols, rowIndex * numCols)"
          :key="userChart.userId"
          col-size="2"
          class="border margin"
        >
          <div
            class="padding"
          >
            <grid-row>
              <h3
                class="header-title padding-bottom">
                {{ userChart.username }}
                <font-awesome-icon
                  class="pointer margin-left-m"
                  :icon="icon.searchPlus"
                  v-on:click="showZoomedView(userChart)"
                />
              </h3>
            </grid-row>

            <health-chart
              :data="userChart.chartData"
              :xAxisFormat="xAxisFormat"
            />
          </div>

        </grid-col>
      </grid-row>
      <zoomed-board-modal
        v-if="showZoomedModal"
        :username="zoomedUsername"
        :data="zoomedChartData"
        :selectedDay="selectedDay"
        :filters="getFilterOptions"
        v-on:close="hideZoomedView"
        v-on:input="updatedZoomViewParameters"
      />
    </div>

    <multiple-user-selector
      v-if="showUserSelectorModal"
      :options="userOptions"
      :selectedUsers="selectedUsers"
      v-on:input="onInputUsers"
      v-on:close="onCloseUserSelector"
    />
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import HealthChart from 'BRAND/components/explorer/HealthChart';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Chevron from '@/components/shared/Chevron';
import HealthExplorerControls from 'BRAND/components/explorer/HealthExplorerControls';
import MultipleUserSelector from 'BRAND/components/explorer/MultipleUserSelector';
import BtnPill from '@/components/shared/buttons/BtnPill';
import api from 'BRAND/api/healthExplorer';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faSearchPlus} from '@fortawesome/pro-solid-svg-icons';
import ZoomedBoardModal from 'BRAND/components/explorer/ZoomedBoardModal';

export default {
  name: 'MultipleBoard',
  components: {
    ZoomedBoardModal,
    MultipleUserSelector,
    MainLayout,
    HealthChart,
    GridRow,
    GridCol,
    Chevron,
    HealthExplorerControls,
    BtnPill,
    FontAwesomeIcon
  },
  data () {
    return {
      icon: {
        searchPlus: faSearchPlus
      },
      showZoomedModal: false,
      listenKeyEvents: true,
      userOptions: [],
      selectedUsers: [],
      usersCharts: [],
      selectedDay: new Date(),
      selectedUser: null,
      selectedFilter: {label: '', id: 1},
      zoomedChartData: null,
      zoomedUsername: null,
      zoomedUserId: null,
      showUserSelectorModal: false,
      maxSelectedUsers: 4,
      numRows: 2,
      numCols: 2,
      xAxisFormat: '%H:%M'
    };
  },
  created () {
    this.requestUsersAccessData();
  },
  computed: {
    getBreadcrumb () {
      return [
        {name: this.$t('health.healthBoard'), link: '/glucoboard'},
        {name: this.$t('health.explorer.multipleBoard.title'), disabled: true}
      ];
    },
    getFilterOptions () {
      let reObj = [{label: this.$t('health.explorer.controls'), id: 1},
        {label: this.$t('health.explorer.controlsDay'), id: 2}];
      return reObj;
    }
  },
  methods: {
    filterChanged (selectValue) {
      this.selectedFilter = selectValue;
      this.requestUsersCharts();
    },
    onInputUsers (selectedUsers) {
      this.selectedUsers = selectedUsers;
      this.requestUsersCharts();
    },
    requestUsersCharts () {
      this.usersCharts = [];
      this.selectedUsers.forEach(user => this.requestUserChart(user.id, user.label));
    },
    showUserSelector () {
      this.listenKeyEvents = false;
      this.showUserSelectorModal = true;
    },
    onCloseUserSelector () {
      this.listenKeyEvents = true;
      this.showUserSelectorModal = false;
    },
    requestUsersAccessData () {
      api.getAccessibleUsers(this).then(data => {
        this.userOptions = data;
        this.selectedUsers = data.slice(0, this.maxSelectedUsers);
        this.requestUsersCharts();
      });
    },
    requestUserChart (userId, username) {
      this.requestUserChartWithDateAndFilter(userId, username, this.selectedDay, this.selectedFilter, (data) => {
        this.usersCharts = this.usersCharts.filter(userChart => userChart.userId !== userId);
        this.usersCharts.push({
          userId: userId,
          username: username,
          chartData: data
        });
        this.usersCharts = this.usersCharts.sort((a, b) => (a.username > b.username) ? 1 : -1);
      });
    },
    requestUserChartWithDateAndFilter (userId, username, selectedDay, selectedFilter, callback) {
      let fromDay;
      let toDay;
      fromDay = selectedDay.getTime();
      toDay = fromDay - (7 * 24 * 60 * 60 * 1000);
      // 100 milliseconds of dealy to prevent date selector's UI freezing
      setTimeout(() => {
        if (selectedFilter.id === 1) {
          // Week view, las 7 days
          toDay = selectedDay.getTime();
          fromDay = toDay - (7 * 24 * 60 * 60 * 1000);
        } else if (selectedFilter.id === 2) {
          fromDay = selectedDay.getTime() - (18 * 60 * 60 * 1000);
          toDay = selectedDay.getTime() + (18 * 60 * 60 * 1000);
        }
        api.getChart(this, fromDay, toDay, userId).then(data => {
          if (data.heart_rate) {
            let heartRate = data.heart_rate.sort((a, b) => {
              return a.timestamp - b.timestamp;
            });
            heartRate.forEach((point, i) => {
              if (i === heartRate.length - 1) {
                return;
              }
              if (point.timestamp + 21600000 < heartRate[i + 1].timestamp) {
                data.heart_rate.push({
                  timestamp: point.timestamp + 1,
                  value: -1
                });
                data.heart_rate.push({
                  timestamp: heartRate[i + 1].timestamp - 1,
                  value: -1
                });
              }
            });
          }
          callback(data);
        });
      }, 100);
    },
    showZoomedView (userChart) {
      this.listenKeyEvents = false;
      this.zoomedChartData = userChart.chartData;
      this.zoomedUserId = userChart.userId;
      this.zoomedUsername = userChart.username;
      this.showZoomedModal = true;
    },
    hideZoomedView () {
      this.listenKeyEvents = true;
      this.showZoomedModal = false;
    },
    updatedZoomViewParameters (parameters) {
      this.requestUserChartWithDateAndFilter(this.zoomedUserId, this.zoomedUsername, parameters.selectedDay, parameters.selectedFilter,
        (data) => {
          this.zoomedChartData = data;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

.header-title {
  float: left;
}

.container {
  padding-top: $sp-margin;
  padding-bottom: $sp-margin;
  flex-grow: 1;
  min-height: 100%;
  @supports (-webkit-touch-callout: none) {
    display: -ms-flexbox;
  }
  @supports not (-webkit-touch-callout: none) {
    display: flex;
  }
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;

  &__title {
    margin-bottom: $sp-margin;
    @media (min-width: $breakpoint) {
      display: flex;
      h1 {
        margin-bottom: 0;
        margin-right: $sp-margin;
        padding-right: $sp-margin;
      }
    }
  }
}

.pointer {
  cursor: pointer;
}

.padding {
  padding: 2%;
}

.margin {
  margin: 10px;
}

.border {
  border: 1px solid black;
  border-radius: 5%;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/MultipleBoard.vue